import {type RouteLocationStringParam, type RouteRecordRaw} from 'vue-router';
import dateHelper from '../utils/portuna/dateHelper';

const EducationEntryList      = () => import('../views/education/entry/EducationEntryList.vue');
const EducationEntryCalendar  = () => import('../views/education/entry/EducationEntryCalendar.vue');
const EducationEntryStateEdit = () => import('../views/education/entry/EducationEntryStateEdit.vue');
const EducationSchoolList     = () => import('../views/education/school/EducationSchoolList.vue');
const EducationSchoolView     = () => import('../views/education/school/EducationSchoolView.vue');
const EducationSchoolEdit     = () => import('../views/education/school/EducationSchoolEdit.vue');
const EducationUserSettings   = () => import('../views/education/settings/EducationUserSettings.vue');

let meta: MetaData = {
    module: 'employee',
};

let education: RouteRecordRaw[] = [
    {
        name: 'education',
        path: '/employee/education',
        redirect: {name: 'education-entry-list'},
        meta: meta,
    },
    {
        name: 'education-index',
        path: '/employee/education/index',
        redirect: {name: 'education-entry-list'},
        meta: meta,
    },
    //<editor-fold desc="Entry">
    {
        name: 'education-entry-list',
        path: '/employee/education/entry/list/:year?/:week?/:state?',
        alias: '/employee/education/entry/list/week/:week?/year/:year?/state/:state?',
        component: EducationEntryList,
        meta: meta,
        props(route: RouteLocationStringParam)
        {
            return {
                year: parseInt(route.params.year) || dateHelper('Y'),
                week: parseInt(route.params.week) || dateHelper('W'),
                state: parseInt(route.params.state) || null,
            };
        },
    },
    {
        name: 'education-entry-calendar',
        path: '/employee/education/entry/calendar',
        component: EducationEntryCalendar,
        meta: meta,
    },
    {
        name: 'education-entry-state-edit',
        path: '/employee/education/entry/state-edit/:id/:year?/:week?',
        component: EducationEntryStateEdit,
        meta: meta,
        props(route: RouteLocationStringParam)
        {
            return {
                id: parseInt(route.params.id),
                year: parseInt(route.params.year) || dateHelper('Y'),
                week: parseInt(route.params.week) || dateHelper('W'),
            };
        },
    },
    //</editor-fold>
    // <editor-fold desc="School">
    {
        name: 'education-school-list',
        path: '/employee/education/school/list',
        component: EducationSchoolList,
        meta: meta,
    },
    {
        name: 'education-school-view',
        path: '/employee/education/school/view/:id',
        component: EducationSchoolView,
        meta: meta,
        props(route: RouteLocationStringParam)
        {
            return {
                id: parseInt(route.params.id) || 0,
            };
        },
    },
    {
        name: 'education-school-edit',
        path: '/employee/education/school/edit/:id',
        component: EducationSchoolEdit,
        meta: meta,
        props(route: RouteLocationStringParam)
        {
            return {
                id: parseInt(route.params.id) || 0,
            };
        },
    },
    //</editor-fold>
    {
        name: 'education-user-settings',
        path: '/employee/education/settings/user',
        component: EducationUserSettings,
        meta: meta,
    },
    // COMPATIBILITY: OLD PATHS
    {
        path: '/employee/education/entry/list/year/:year/week/:week',
        redirect: {name: 'education-entry-list'},
    },
];

export default education;